package com.essntl.features.tag.domain.model

data class TagModel(
    val id: String,
    val name: String,
) {
    fun getChangedFields(tagModel: TagModel) =
        TagModel(
            id = id,
            name = if (name.lowercase().capitalize() != tagModel.name.lowercase().capitalize()) tagModel.name else "",
        )

    val isEmpty get() = this.copy(id = "") == empty

    companion object {
        val empty =
            TagModel(
                id = "",
                name = "",
            )
    }
}
